export const OTP_FAIL_EVENT = "optfail";

export class OtpFailEvent extends Event {
  constructor() {
    super(OTP_FAIL_EVENT);
  }
}
